import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Tooltip, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Grid from '@mui/material/Grid2';
import { observer } from 'mobx-react';
import dashboardStore from 'store/dashboardStore';
import { ColorsMap } from './config/config';
import M from 'messages';
import classes from './styles';

const KPIGlobalSection = observer(() => (
  <Grid container spacing={2} sx={{ mt: 3 }}>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.allWines }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.allFollowers')}
            <Tooltip placement="top" title={M.get('dashboard.allFollowersTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIGlobalDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.totalFollowers}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.visits }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.totalVisits')}
            <Tooltip placement="top" title={M.get('dashboard.totalVisitsTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIGlobalDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.totalVisits}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.averageRating }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.averageRating')}
            <Tooltip placement="top" title={M.get('dashboard.averageRatingTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIGlobalDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.averageRating}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.ratings }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.totalRatings')}
            <Tooltip placement="top" title={M.get('dashboard.totalRatingsTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIGlobalDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.totalRatings}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
  </Grid>
));

export default KPIGlobalSection;
